import FeedbackComponent from '@/components/base/FeedbackComponent'
import ShowDocumentsComponents from "@/components/dashboard/search-customer-service/ShowDocumentsComponents.vue";
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import GridWidget from '@payroll/grid-widget/src/component/GridWidget.vue'
import {GridColumn} from '@payroll/grid-widget/src/models/GridColumn';
import {BaseRequest, KeyValuePair, UserDetailsResponse} from '@payroll/optimus-common'
import {FieldType, SearchFieldModel} from '@payroll/search-results-widget/src/models/SearchField.model';
import Component from 'vue-class-component'
import {Action, Getter, Mutation} from 'vuex-class'

@Component({
  components: {
    ShowDocumentsComponents,
  }
})
export default class SearchCustomerServiceComponent extends FeedbackComponent {

  @Action('getAttachmentContactMe', StoreNamespace.SEARCH) getAttachmentContactMe: any
  @Action('searchCustomerServiceMessages', StoreNamespace.SEARCH) searchCustomerServiceMessages: any
  @Action('updateCustomerServiceMessage', StoreNamespace.SEARCH) updateCustomerServiceMessage: any
  @Action('getCustomerServiceStatuses', StoreNamespace.SEARCH) getCustomerServiceStatuses: any
  @Action('getCustomerServiceSubjects', StoreNamespace.SEARCH) getCustomerServiceSubjects: any
  @Action('getPortalTypes', StoreNamespace.SEARCH) getPortalTypes!: any

  @Mutation('setPortalTypes', StoreNamespace.SEARCH) setPortalTypes!: any

  @Getter('portalTypes', StoreNamespace.SEARCH) portalTypes!: KeyValuePair[]
  @Getter('userDetails', StoreNamespace.AUTHENTICATION) userDetails!: UserDetailsResponse

  private searchFields: SearchFieldModel[] = []
  private columns: GridColumn[] = []
  private showModal: boolean = false
  private selectedMessage: any = null
  private statuses: KeyValuePair[] = []
  private subjects: any[] = []
  private modalErrorMessages: string[] = []
  private remarks: string = ''
  private status: KeyValuePair = {} as KeyValuePair
  private searchObject: any = {}
  private firstTimeLoad: boolean = true
  private attachments: any[] = [];

  mounted() {
    this.getPortalTypes({requestorCallback: this})
    this.initColumns()
    this.initSearchFields()
  }

  private initColumns(): void {
    this.columns.push({property: 'reference'} as GridColumn)
    this.columns.push({property: 'portalType', header: 'portal'} as GridColumn)
    this.columns.push({property: 'dateCreated', header: 'date'} as GridColumn)
    this.columns.push({property: 'fullName', header: 'applicantName'} as GridColumn)
    this.columns.push({property: 'applicantId', header: 'identification_number'} as GridColumn)
    this.columns.push({property: 'msgSubject.description', header: 'subject'} as GridColumn)
    this.columns.push({property: 'status.description', header: 'status'} as GridColumn)
  }

  private initSearchFields(): void {
    if (this.statuses.length === 0 || this.subjects.length === 0 || this.portalTypes.length === 0) {
      return
    }

    this.searchFields.push({
      label: 'portal_type',
      property: 'portalType',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.portalTypes,
      unSelectFirst: true
    })

    this.searchFields.push({
      label: 'status',
      property: 'status',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.statuses,
      unSelectFirst: true
    })

    this.searchFields.push({
      label: 'identification_number_hp_or_id',
      property: 'applicantId',
      fieldType: FieldType.TEXT_FIELD,
      maxLength: 16
    })
    this.searchFields.push({
      label: 'reference',
      property: 'reference',
      fieldType: FieldType.TEXT_FIELD,
      maxLength: 25,
      advancedOnly: true
    })
    this.searchFields.push({
      label: 'start_date',
      property: 'dateCreatedFrom',
      fieldType: FieldType.DATE_FIELD,
      advancedOnly: true
    })
    this.searchFields.push({
      label: 'end_date',
      property: 'dateCreatedTo',
      fieldType: FieldType.DATE_FIELD,
      advancedOnly: true
    })
    this.searchFields.push({
      label: 'subject',
      property: 'msgSubject',
      fieldType: FieldType.SELECT_FIELD,
      selectOptions: this.subjects,
      unSelectFirst: true,
      advancedOnly: true
    })
  }

  loadCustomerServiceMessages(searchObject: any) {
    this.searchCustomerServiceMessages({
      requestBody: searchObject as BaseRequest,
      requestorCallback: this
    })
    this.searchObject = searchObject
  }

  onSuccess(data?: any, requestName?: any, message?: any) {
    switch (requestName) {
      case 'getCustomerServiceStatuses':
        this.statuses = data
        this.initSearchFields()
        break
      case 'getCustomerServiceSubjects':
        this.subjects = data
        this.initSearchFields()
        break
      case 'searchCustomerServiceMessages':
        if (this.firstTimeLoad) {
          this.firstTimeLoad = false
          this.getCustomerServiceStatuses({
            requestorCallback: this
          })
          this.getCustomerServiceSubjects({
            requestorCallback: this
          })
        }
        this.$emit('successResults', data)
        break
      case 'updateCustomerServiceMessage':
        this.showModal = false
        this.searchCustomerServiceMessages({
          requestBody: this.searchObject,
          requestorCallback: this
        })
        break
      case 'getPortalTypes':
        this.setPortalTypes(data)
        this.loadCustomerServiceMessages({
          pageNumber: 0,
          pageSize: GridWidget.DEFAULT_PAGE_SIZE
        })
        break
      case 'getAttachmentContactMe':
        this.attachments = data;
        break
    }
  }

  onRowClick(data: any) {
    this.getAttachmentContactMe({
      requestorCallback: this,
      pathVariable: data.id,
    })

    this.showModal = true
    if (!data.responserName) {
      data.responserName = this.userDetails.fullName
    }
    if (!data.responseDate) {
      data.responseDate = new Date().toLocaleDateString('en-GB')
    }
    this.selectedMessage = data
    this.remarks = this.selectedMessage.responseText
    this.status = this.selectedMessage.status
  }

  onSaveResponse(): void {
    this.updateCustomerServiceMessage({
      pathVariable: this.selectedMessage.id,
      requestBody: {
        id: this.selectedMessage.id,
        fullName: this.selectedMessage.fullName,
        phoneNum: this.selectedMessage.phoneNum,
        email: this.selectedMessage.email,
        msgSubject: this.selectedMessage.msgSubject,
        msgBody: this.selectedMessage.msgBody,
        responseText: this.remarks,
        status: this.status
      },
      requestorCallback: this
    })
  }

  onError(messages: string[], code: number, requestName?: string): void {
    if (requestName === 'updateCustomerServiceMessage' && code === 400) {
      this.modalErrorMessages = messages
    } else {
      switch (code) {
        case 400:
        case 500:
          this.serverErrorMessages = messages
          break
        case 401:
        case 403:
          this.$router.push({name: 'session-timeout'})
          break
        case 404:
          this.$router.push({name: 'not-found'})
          break
        case 503:
          this.$router.push({name: 'maintenance'})
          break
        default:
          this.$router.push({name: 'error'})
          break
      }
    }
  }
}